import { API_URLS } from "../../../config/urls";
import { call, put } from 'redux-saga/effects'
import { CallApi } from "./api/callApi";
import { createdPayslip } from "../../redux/slices/payslipSlice";
export function* listPayslipSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.PAYSLIP.ROUTE, data?.data, data?.token);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}
export function* listMyPayslipSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.PAYSLIP.ME, data?.data, data?.token);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

export function* detailsPayslipSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.PAYSLIP.SPECIFIC.replace(":id", data?.data?.id), data?.data, data?.token);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* createPayslipSaga(action) {
    try {
        const data = action.payload;

        const resp = yield call(CallApi.POST, data?.data?.type === "new" ? API_URLS.PAYSLIP.NEW_PAYSLIP_ROUTE : API_URLS.PAYSLIP.ROUTE, data?.data, data?.token);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(createdPayslip())
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            yield put(createdPayslip())
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        yield put(createdPayslip())
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* deletePayslipSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, API_URLS.PAYSLIP.ROUTE, data?.data, data?.token);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* getBulkDownloadLinksSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.PAYSLIP.DOWNLOAD, data?.data, data?.token);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}